import React from 'react'
import { useAuthState } from 'react-firebase-hooks/auth'
import { auth } from '../../../Firebase/firebase.init'

const BookingModal = ({hotelName, setHotelName}) => {
    const [user] = useAuthState(auth)

    return (
        <div>
            <input type="checkbox" id="hotel-booking-modal" className="modal-toggle" />
            <div className="modal modal-bottom sm:modal-middle">
            <div className="modal-box relative">
                <label htmlFor="hotel-booking-modal" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                <h3 className="font-bold text-lg">Hello {user?.displayName},</h3>
                <p className="py-4">Are you sure you want to book {hotelName}?</p>
                <div className="modal-action">
                    <label onClick={() => setHotelName('')} htmlFor="hotel-booking-modal" className="btn">Cancel</label>
                    <label onClick={() => setHotelName('')} htmlFor="hotel-booking-modal" className="btn">Confirm</label>
                </div>
            </div>
            </div>
        </div>
    );
};

export default BookingModal;